"use client";

import Image from "next/image";
import { fontWeights } from "@/utils/fonts";

interface PortfolioHeroProps {
  title?: string;
  description?: string;
  image?: string;
}

export function PortfolioHero({
  title,
  description,
  image
}: PortfolioHeroProps) {
  const displayTitle = title || "";
  const displayDescription = description || "";
  const displayImage = image || "";

  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-r from-[#f4faff] via-[#f9fcff] to-white py-4 sm:py-8 lg:py-10 xl:py-[50px]">
      <div className="max-w-[1630px] mx-auto px-4 sm:px-6 sm:px-10 justify-center">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-2 sm:gap-3 md:gap-4 xl:gap-6 2xl:gap-10">

          {/* Text Content */}
          <div className="flex-1 max-w-auto">
            <h2
              className="text-[#0A165E] leading-tight mb-3 sm:mb-4 lg:mb-6 
                tracking-normal 
                md:tracking-[-1px] 
                lg:tracking-[-1.5px] 
                xl:tracking-[-2px]
                text-[22px] 
                sm:text-[32px] 
                md:text-[35px] 
                lg:text-[48px] 
                xl:text-[60px]"
              style={{ fontFamily: "Lato", fontWeight: fontWeights.lato.bold }}
            >
              {displayTitle}
            </h2>

            <p
              className="text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] text-[#0A165E] leading-[20px] sm:leading-relaxed lg:text-left text-center"
              style={{ fontFamily: "Asap", fontWeight: fontWeights.asap.regular }}
            >
              {displayDescription}
            </p>
          </div>

          {/* Image Section */}
          {displayImage && (
            <div className="flex-1 relative w-full flex justify-center lg:justify-end items-end h-full">
              <div className="relative border border-[#015db9] border-[2px] rounded-[10px] sm:rounded-[12px]"> {/* Add some space above the image on mobile */}
                <Image
                  src={displayImage}
                  alt={displayTitle}
                  width={528}
                  height={420}
                  className="object-contain block w-[280px] tsm-400:w-[328px] sm:w-[378px] md:w-[428px] lg:w-[478px] xl:w-[528px] "
                  priority
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Fading Gradient Bottom Line (Darker in middle) */}
      <div className="absolute bottom-0 left-0 w-full flex justify-center">
        <div className="w-full h-[2px] sm:h-[4px] bg-gradient-to-r from-transparent via-[#015db9] to-transparent" />
      </div>
    </section>
  );
}
